import { gql } from '@apollo/client';

import { Payment } from '../../../types/payments';
import { paymentFragment } from '../fragments';

export interface GetCoursePaymentsQueryVariables {
  academyId: string;
  courseId: string;
  year: string;
  month: string;
}

export interface GetCoursePaymentsQueryResult {
  payments: Payment[];
}

export const getCoursePaymentsQuery = gql`
  query GetCoursePaymentsQuery($academyId: String!, $courseId: String!, $year: String!, $month: String!) {
    payments(academyId: $academyId, courseId: $courseId, year: $year, month: $month)
      @rest(type: "Payment", path: "payments/{args.academyId}/{args.courseId}/{args.year}/{args.month}") {
      ...Payment
    }
  }
  ${paymentFragment}
`;
